<template>
  <el-card class="record">
    <el-row :gutter="20" class="mb-4">
      <el-col :md="5" class="search-item">
        <el-select v-model="params.search" :placeholder="$t('messages.myCampaign.list6')" @keyup.native="getList" clearable>
          <el-option
            v-for="item in recordTypeOptions"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :md="5" class="search-item">
        <el-input
          v-model="params.cpid"
          :placeholder="$t('messages.myCampaign.list8')"
          style="min-width: 100px;"
        ></el-input>
      </el-col>
      <el-col :md="5" class="search-item" v-if="isAgent">
        <el-input
          v-model="params.developer_name"
          :placeholder="$t('messages.myCampaign.list7')"
          style="min-width: 100px;"
        ></el-input>
      </el-col>
      <el-col :md="6" class="search-btn">
        <el-button type="primary" @click="getList">{{$t('messages.myCampaign.list43')}}</el-button>
        <el-button type="primary" @click="exportAll">{{$t('messages.myCampaign.list45')}}</el-button>
      </el-col>
    </el-row>
    <el-row class="record-table">
      <el-table v-loading="loading" :empty-text="$t('messages.myCampaign.list10')" :fit="true" border :data="list">
        <el-table-column prop="id" :label="$t('messages.record.record11')" :width="showMobile ? 50 : 130"></el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list6')" :width="showMobile ? 50 : 155">
          <template slot-scope="scope">
            {{ getRecordTypeLabel(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('messages.myCampaign.list155')" :width="showMobile ? 65 : 130">
          <template slot-scope="scope">
            {{ `$ ${scope.row.amount}` }}
          </template>
        </el-table-column>
        <el-table-column prop="cpid" :label="$t('messages.myCampaign.list8')" :width="showMobile ? 50 : 130"></el-table-column>
        <el-table-column prop="developer_name" :label="$t('messages.record.record14')" :width="100" v-if="isAgent">
          <template slot-scope="scope">
            {{ scope.row.developer_name || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="ct" :label="$t('messages.record.record12')" v-if="showMobile" :width="80">
          <template slot-scope="scope">
            {{ formatDate(scope.row.ct) }}
          </template>
        </el-table-column>
        <el-table-column prop="ct" :label="$t('messages.record.record12')" width="220px" v-else></el-table-column>
        <el-table-column prop="detail" :label="$t('messages.record.record13')"></el-table-column>
      </el-table>
    </el-row>
    <pagination
      :page="page"
      @sizeChange="getList"
      @currentChange="getList"
      :pagerCount="showMobile ? 5 : 7"
    ></pagination>
  </el-card>
</template>

<script>
import pagination from '../../components/pagination.vue'
import { recordTypeOptions as RECORD_TYPE_OPTIONS } from '@/js/varible'

export default {
  components: {
    pagination,
  },
  data() {
    return {
      loading: false,
      params: {
        type: '',
        developer_name: '',
        cpid: '',
      },
      list: [],
      page: {
        tot: 0,
        cur: 1,
        per: 20,
      },
      showMobile: false,
    }
  },
  created() {
    this.getList()
    window.addEventListener('resize', this.move)
    let width = document.body.clientWidth || document.documentElement.clientWidth
    this.showMobile = width < 801
  },
  move() {
    let width = document.body.clientWidth || document.documentElement.clientWidth
    this.showMobile = width < 801
  },
  destroyed() {
    window.removeEventListener('resize', this.move)
  },
  methods: {
    getRecordTypeLabel(type) {
      const option = RECORD_TYPE_OPTIONS.find(item => item.value === type)
      return option ? this.$t(option.labelKey) : type
    },
    exportAll() {
      this.loading = true
      this.$http
        .get('/api/deposit/records/', {
          params: {
            ...this.params,
            is_export: 1,
          },
        })
        .then(res => {
          this.loading = false
          const fileName = 'Record.csv';  
          let newData = this.handleExcelData(res)
          this.exportToCSV(newData, fileName,'csv');
        })
        .catch(err => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    getList() {
      this.loading = true
      this.$http
        .get('/api/deposit/records/', {
          params: {
            ...this.params,
            p: this.page ? this.page.cur : 1,
            n: this.page ? this.page.per : 20,
          },
        })
        .then(data => {
          this.loading = false
          this.list = data.data
          this.changePageItem(this.page, data)
        })
        .catch(err => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
  },
  computed:{
    recordTypeOptions() {
      return RECORD_TYPE_OPTIONS.map(item => ({
        value: item.value,
        label: this.$t(item.labelKey),
      }))
    },
    isAgent(){
      return this.$store.state.profile.customer_type === 1
    },
  }
}
</script>

<style lang="scss">
.record {
  margin-bottom: 24px;
}
@media screen and (max-width: 993px) {
  .record {
    .search-item,
    .search-btn {
      width: auto !important;
    }
  }
}
@media screen and (max-width: 801px) {
  .record {
    .el-card__body {
      padding-left: 10px;
      padding-right: 10px;
    }
    .record-table {
      margin-bottom: 10px;
      .el-table th.el-table__cell > .cell {
        padding-left: 4px !important;
        padding-right: 4px !important;
        text-align: center !important;
      }
      .el-table td.el-table__cell div {
        padding-left: 4px !important;
        padding-right: 4px !important;
        text-align: center !important;
        overflow: inherit;
        white-space: initial;
        word-break: break-word;
      }

      .el-table th > .cell {
        padding-left: 4px !important;
        padding-right: 4px !important;
        text-align: center !important;
        overflow: inherit;
        white-space: break-spaces;
        word-break: break-word;
      }

      .el-card__body {
        padding-left: 14px !important;
        padding-right: 10px !important;
      }
    }
    .pagination {
      .el-row--flex.is-justify-space-between {
        flex-direction: column-reverse !important;
        align-items: flex-start !important;
      }
    }
  }
}

@media screen and (max-width: 420px) {
  .record {
    .search-item {
      width: 60% !important;
    }
  }
}
</style>
